/**
 * The error tint, in one place (M6c step 0f).
 *
 * `theme.other.errorTint` (`theme/theme.ts`) names the colours — `'#e0938c on rgba(224,100,92,.35)'`,
 * commented "failed jobs — NOT the accent" — but as a documentation string, not as usable CSS. So
 * every surface that needed it wrote its own pair, and by M6c there were several: `Review.tsx`'s
 * dictation diff, `Words.tsx`'s destructive action, `JobPill.tsx`'s failed job. They had already
 * begun to differ in alpha.
 *
 * M6c adds a fourth and much more visible surface — the correction underline under a learner's own
 * sentence — and a milestone whose whole subject is "do not draw a mark in the wrong place" is the
 * wrong one to add a fifth copy in. So the two values live here and are imported.
 *
 * `theme.ts` is a PROTECTED ARTIFACT, byte-identical to the design handoff's copy, and is not
 * edited to add a token; that is why this module exists beside it rather than inside it.
 *
 * Why not the accent: the accent means "this is yours". Painting a learner's mistake with the
 * colour the app uses to say "yours" would be a small cruelty, and `reading-surface-spec.md` §7
 * says it outright — "failure states use the coral-red error tint — never the accent".
 */

/** Text and icon colour for an error state. */
export const ERROR_INK = 'light-dark(#b0433b, #e0938c)';
/** `text-decoration-color` for an error underline. */
export const ERROR_RULE = 'light-dark(rgba(176,67,59,.7), rgba(224,100,92,.7))';
